export enum MarquisType {
  WINDOW,
  TERRACE,
  ROLL,
  WINDOW2,
}
